export default {"src":"/_next/static/media/quote-icon.cc53503e.svg","height":21,"width":26,"blurWidth":0,"blurHeight":0};